import * as Flux from 'dg-web-shared/lib/Flux.tsx';
import { createLocalStorageLanguageAccessor } from 'dg-web-shared/lib/LocalStorageLanguageAccessor.ts';
import { isLanguage, Language } from 'dg-web-shared/lib/Localized.ts';
import {
    getBrowserLanguage,
    getLocalStorageLanguage,
    setLocalStorageLanguage,
} from 'dg-web-shared/lib/useSystemLanguage.ts';

export interface State {
    language: string;
}

const [getLegacyPortalLocalStorageLanguage] =
    createLocalStorageLanguageAccessor('parkingportal_language', true);

function getCleanLocalStorageLanguage() {
    const language = getLocalStorageLanguage();
    if (language !== Language.EN) {
        return language;
    } else {
        return null;
    }
}

function setCleanLocalStorageLanguage(language: unknown) {
    if (isLanguage(language, true)) {
        setLocalStorageLanguage(language);
    }
}

export class StateSlice extends Flux.StateSlice<State> {
    key(): string {
        return 'common-SettingsState';
    }

    sideEffects(_store: Flux.Store): void {
        // nop
    }

    getInitialState(): State {
        const localStorageLanguage = getCleanLocalStorageLanguage();
        const legacyLocalStorageLanguage =
            getLegacyPortalLocalStorageLanguage();
        if (
            localStorageLanguage === null &&
            legacyLocalStorageLanguage !== null
        ) {
            setCleanLocalStorageLanguage(legacyLocalStorageLanguage);
        }
        return {
            language:
                localStorageLanguage ??
                legacyLocalStorageLanguage ??
                getBrowserLanguage(true) ??
                Language.DE,
        };
    }

    writeLanguage(language: string): void {
        setCleanLocalStorageLanguage(language);
        this.set((s: State) => {
            s.language = language;
            return s;
        });
    }

    writeLanguageFromServer(language: string): void {
        this.set((s: State) => {
            s.language =
                getCleanLocalStorageLanguage() ??
                getLegacyPortalLocalStorageLanguage() ??
                language;
            return s;
        });
    }
}
